import React from "react";

const Button = ({ size, className, text, label, onClick, type, icon }) => {
  return (
    <>
      <div>
        <button type={type} size={size} className={className} onClick={onClick} icon={icon}>
          {label  || text}
        </button>
      </div>
    </>
  );
};

export default Button;
